// tenantConfig.js
import RipcordLoginLogo from "../image/Ripcord+W_Login.png";
import WaterCompanyLogo from "../image/WaterCompanyLogo.png";
import CarCompanyLogo from "../image/CarCompanyLogo.png";
import HeaterCompanyLogo from "../image/HeaterCompanyLogo.png";
import RipcordCompanyLogo from "../image/Ripcord+W.png";
import CelsiusLogo from "../image/Celsius.png";

export const tenantConfig = {
  ripcord: {
    loginLogo: RipcordLoginLogo,
    loginTitle: "Log in to Ripcord Platform",
    companyLogo: RipcordCompanyLogo,
    dashboardTitle: "Instant IoT Platform",
    welcomeMessage: "Enjoy the Ripcord Platform",

    theme: {
      highlightColor: "#2d22b2",
      backgroundColor: "#f8f8f8",
    }
  },
  heater: {
    loginLogo: HeaterCompanyLogo,
    loginTitle: "Welcome to EverWarm Heating Systems",
    companyLogo: HeaterCompanyLogo,
    dashboardTitle: "EverWarm Operations Centre",
    welcomeMessage: "Optimise performance, and keep every site running efficiently",

    theme: {
      highlightColor: "#B91C1C",
      backgroundColor: "#FEF2F2",
    }
  },
  water: {
    loginLogo: WaterCompanyLogo,
    loginTitle: "Welcome to BlueRiver Water",
    companyLogo: WaterCompanyLogo,
    dashboardTitle: "BlueRiver Network Control",
    welcomeMessage: "Monitor water infrastructure, and maintain uninterrupted service",

    theme: {
      highlightColor: "#00AEEF",
      backgroundColor: "#EFE4B0",
    }
  },
  car: {
    loginLogo: CarCompanyLogo,
    loginTitle: "Welcome to Sterling Vehicle Systems",
    companyLogo: CarCompanyLogo,
    dashboardTitle: "Sterling Manufacturing Hub",
    welcomeMessage: "Monitor production lines, and maximise factory uptime.",

    theme: {
      highlightColor: "#1F1A17",
      backgroundColor: "#FBCF30",
    }
  },
  celsius: {
    loginLogo: CelsiusLogo,
    loginTitle: "Welcome to Celsius Medical Refrigeration",
    companyLogo: CelsiusLogo,
    dashboardTitle: "Celsius Medical Refrigeration",
    welcomeMessage: "Monitor medical refrigeration proactively, safeguard medical storage.",

    theme: {
      highlightColor: "#FF5757",
      backgroundColor: "#f8f8f8",
    }
  },
};
